import { render, staticRenderFns } from "./BundleCard.vue?vue&type=template&id=2e7996d8&scoped=true"
import script from "./BundleCard.vue?vue&type=script&lang=js"
export * from "./BundleCard.vue?vue&type=script&lang=js"
import style0 from "./BundleCard.vue?vue&type=style&index=0&id=2e7996d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7996d8",
  null
  
)

export default component.exports